import { StyleSheet } from 'react-native';
import { ThemeColors } from '../../common/theme-colors';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.pink,
    },
  });
